module.exports = __webpack_public_path__ + "media/images/shared/delivery/uts-94b7aa1283eef482bb48fec5a8cd901a.png";